function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';
const BaseComponent = ({
  size = 24,
  title,
  desc,
  titleId,
  descId,
  tabIndex = -1,
  focusable = false,
  role = 'img',
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  let ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? ` ${descId}` : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": ariaHidden,
    fill: "currentcolor",
    role: role,
    tabIndex: tabIndex,
    focusable: focusable
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("path", {
    d: "M15.65 10.675c.375 0 .694-.131.956-.394.263-.262.394-.581.394-.956s-.131-.694-.394-.956a1.302 1.302 0 00-.956-.394c-.375 0-.694.131-.956.394a1.302 1.302 0 00-.394.956c0 .375.131.694.394.956.262.263.581.394.956.394zm-7.3 0c.375 0 .694-.131.956-.394.263-.262.394-.581.394-.956s-.131-.694-.394-.956a1.302 1.302 0 00-.956-.394c-.375 0-.694.131-.956.394A1.302 1.302 0 007 9.325c0 .375.131.694.394.956.262.263.581.394.956.394zm3.654 2.9c-1.12 0-2.133.313-3.041.938A5.568 5.568 0 006.95 17h1.325c.367-.7.885-1.242 1.554-1.625a4.327 4.327 0 012.188-.575c.789 0 1.512.196 2.17.587.659.392 1.18.93 1.563 1.613h1.3a5.301 5.301 0 00-1.996-2.5 5.332 5.332 0 00-3.05-.925zM12 22a9.738 9.738 0 01-3.9-.788 10.099 10.099 0 01-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.738 9.738 0 012 12c0-1.383.263-2.683.788-3.9a10.099 10.099 0 012.137-3.175c.9-.9 1.958-1.612 3.175-2.137A9.738 9.738 0 0112 2c1.383 0 2.683.263 3.9.788a10.098 10.098 0 013.175 2.137c.9.9 1.613 1.958 2.137 3.175A9.738 9.738 0 0122 12a9.738 9.738 0 01-.788 3.9 10.098 10.098 0 01-2.137 3.175c-.9.9-1.958 1.613-3.175 2.137A9.738 9.738 0 0112 22z"
  }));
};
const SvgFrown = styled(BaseComponent).withConfig({
  displayName: "Frown__SvgFrown",
  componentId: "sc-gl5ir8-0"
})(["outline:none;"]);
SvgFrown.isIcon = true;
export default SvgFrown;